import { Action } from '@ngrx/store';
import { RuleSet } from 'ngx-angular-query-builder';
import {ListType} from "@common/enums/list-type";

export const LOAD_WIDGET_FILTER = '[Filter] Load Widget Filter';
export const LOAD_WIDGET_FILTER_COMPLETE = '[Filter] Load Widget Filter Complete';
export const LOAD_WIDGET_FILTER_ERROR = '[Filter] Load Widget Filter Error';

export const UPDATE_WIDGET_FILTER = '[Filter] Update Widget Filter';
export const UPDATE_WIDGET_FILTER_COMPLETE = '[Filter] Update Widget Filter Complete';
export const UPDATE_WIDGET_FILTER_ERROR = '[Filter] Update Widget Filter Error';

export const LOAD_LIST_TYPE_FILTER = '[Filter] Load List Type Filter';
export const LOAD_LIST_TYPE_FILTER_COMPLETE = '[Filter] Load List Type Filter Complete';
export const LOAD_LIST_TYPE_FILTER_ERROR = '[Filter] Load List Type Filter Error';

export const SAVE_LIST_TYPE_FILTER = '[Filter] Save List Type Filter';
export const SAVE_LIST_TYPE_FILTER_COMPLETE = '[Filter] Save List Type Filter Complete';
export const SAVE_LIST_TYPE_FILTER_ERROR = '[Filter] Save List Type Filter Error';

export class WidgetFilterActionPayload {
  constructor(public widgetId: number, public filter?: RuleSet) { }
}

export class ListTypeFilterActionPayload {
  constructor(public listType: ListType, public filter?: RuleSet) { }
}

export class LoadWidgetFilter implements Action {
  readonly type = LOAD_WIDGET_FILTER;
  constructor(public payload: WidgetFilterActionPayload) { }
}

export class LoadWidgetFilterComplete implements Action {
  readonly type = LOAD_WIDGET_FILTER_COMPLETE;
  constructor(public payload: WidgetFilterActionPayload) { }
}

export class LoadWidgetFilterError implements Action {
  readonly type = LOAD_WIDGET_FILTER_ERROR;
  constructor(public payload: WidgetFilterActionPayload, public error?: any ) { }
}

export class LoadListTypeFilter implements Action {
  readonly type = LOAD_LIST_TYPE_FILTER;
  constructor(public payload: ListTypeFilterActionPayload) { }
}

export class LoadListTypeFilterComplete implements Action {
  readonly type = LOAD_LIST_TYPE_FILTER_COMPLETE;
  constructor(public payload: ListTypeFilterActionPayload) { }
}

export class LoadListTypeFilterError implements Action {
  readonly type = LOAD_LIST_TYPE_FILTER_ERROR;
  constructor(public payload: ListTypeFilterActionPayload, public error?: any ) { }
}

export class UpdateWidgetFilter implements Action {
  readonly type = UPDATE_WIDGET_FILTER;
  constructor(public payload: WidgetFilterActionPayload) { }
}

export class UpdateWidgetFilterComplete implements Action {
  readonly type = UPDATE_WIDGET_FILTER_COMPLETE;
  constructor(public payload: WidgetFilterActionPayload) { }
}

export class UpdateWidgetFilterError implements Action {
  readonly type = UPDATE_WIDGET_FILTER_ERROR;
  constructor(public payload: WidgetFilterActionPayload, public error?: any) { }
}

export class SaveListTypeFilter implements Action {
  readonly type = SAVE_LIST_TYPE_FILTER;
  constructor(public payload: ListTypeFilterActionPayload) { }
}

export class SaveListTypeFilterComplete implements Action {
  readonly type = SAVE_LIST_TYPE_FILTER_COMPLETE;
  constructor(public payload: ListTypeFilterActionPayload) { }
}

export class SaveListTypeFilterError implements Action {
  readonly type = SAVE_LIST_TYPE_FILTER_ERROR;
  constructor(public payload: ListTypeFilterActionPayload, public error?: any) { }
}

export type WidgetFilterActions =
  LoadWidgetFilter |
  LoadWidgetFilterComplete |
  LoadWidgetFilterError |
  UpdateWidgetFilter |
  UpdateWidgetFilterComplete |
  UpdateWidgetFilterError;

export type ListTypeFilterActions =
  LoadListTypeFilter |
  LoadListTypeFilterComplete |
  LoadListTypeFilterError |
  SaveListTypeFilter |
  SaveListTypeFilterComplete |
  SaveListTypeFilterError;
